import {useState} from "react";
import {Modal} from "react-bootstrap";
import {useCookies} from "react-cookie";
import {GiEuropeanFlag} from "react-icons/gi";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {isUSRegion} from "@/region.ts";

const COOKIE = "eu_disclaimer_seen";

export const EUDisclaimer = () => {
  const [cookies, setCookie] = useCookies([COOKIE]);
  const [show, setShow] = useState(!cookies.eu_disclaimer_seen);
  if (isUSRegion()) {
    return null;
  }

  const onClose = () => {
    setShow(false);
    // we have a year to remove this banner
    setCookie(COOKIE, "1", {path: "/", maxAge: 60 * 60 * 24 * 365});
  };

  const mainDomain = window.location.hostname.replace("eu.", "");
  return (
    <Modal show={show} centered size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        <Icon style={{color: "#3390d8"}} icon={GiEuropeanFlag} size="menuIcon" />
        <span className="ms-1">You are entering Uptime’s new EU data region.</span>
      </Modal.Header>
      <Modal.Body>
        <p>
          Currently, Uptime EU is in Beta. This region features a next generation Check execution engine as well as new
          Probe Locations which will ultimately be rolled out to the rest of Uptime.com. For this reason, Uptime EU may
          not be at feature parity with the standard Uptime region experience, with select features temporarily not
          accessible or visible in Uptime EU.
        </p>
        <p className="mt-2">
          Your early feedback on the EU region is invaluable - please don’t hesitate to report your findings here{" "}
          <Link to={`/contact`} target="_blank">
            Contact Us
          </Link>
          .
        </p>
        <p className="mt-2">
          If you are looking for the complete Uptime experience please use our North America region:{" "}
          <a href={mainDomain}>Uptime.com</a>.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-block m-auto">
          <Button size="large" onClick={onClose}>
            Got It!
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
